import React, { useEffect, useState } from "react";
import { Form, InputNumber, Button, Select, Input } from "antd";
import { createHoleOutPrice } from "../../features/hole-out-price/holeOutPriceSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message as msg } from "antd";
const { Option } = Select;

const CreateHoleOutPrice = () => {
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [priceType, setPriceType] = useState("stripe");

  const { isError, creating, message, isCreateSuccess } = useSelector(
    (state) => state.holeOutPrice
  );

  const onFinish = (data) => {
    console.log(data);
    dispatch(createHoleOutPrice(data));
  };

  useEffect(() => {
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }

    if (isCreateSuccess) {
      messageApi.open({
        type: "success",
        content: "Price created successfully",
      });
    }

    if (isCreateSuccess) {
      navigate("/admin/hole-out-price");
    }
  }, [isError, message, isCreateSuccess, messageApi, navigate]);

  const handlePriceTypeChange = (value) => {
    setPriceType(value);
  };

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Credit Price</h3>
      <Form
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ period: "month", status: "1", currency: "aud", price_type: "stripe" }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input the name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Currency"
          name="currency"
          rules={[{ required: true, message: "Please select the currency!" }]}
        >
          <Select>
            <Option value="aud">AUD</Option>
            <Option value="usd">USD</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Price"
          name="amount"
          rules={[{ required: true, message: "Please input the price!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          label="Credit"
          name="credits"
          rules={[{ required: true, message: "Please input the credits!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Price Type"
          name="price_type"
          rules={[{ required: true, message: "Please select the price type!" }]}
        >
          <Select onChange={handlePriceTypeChange}>
            <Option value="stripe">Stripe</Option>
            <Option value="iap">IAP</Option>
          </Select>
        </Form.Item>

        {priceType === "iap" && (
          <Form.Item
            label="In App Product ID"
            name="in_app_product_id"
            rules={[
              { required: true, message: "Please input the in app product id!" },
            ]}
          >
            <Input />
          </Form.Item>
        )}

        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select the status!" }]}
        >
          <Select>
            <Option value="1">Active</Option>
            <Option value="0">Inactive</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={creating}>
            {creating ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateHoleOutPrice;
